//React
import React from "react";

//UI
import { Select as AntDSelect } from "antd";

//CSS
import "./styles/select.css";


const Select = (props) => {
  return <AntDSelect className="custom-select" {...props} />;
};

export default Select;
